module.exports = "../../static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 1065
// module chunks = 0